type MessagePart = { type: string; text?: string; state?: string };

/** Collect this response's reasoning blocks and their streaming state. */
export function getChatReasoning(parts: readonly MessagePart[]) {
  const reasoning = parts.filter((part) => part.type === "reasoning");

  return {
    text: reasoning.map((part) => part.text?.trim()).filter(Boolean).join("\n\n"),
    isStreaming: reasoning.some((part) => part.state === "streaming"),
  };
}
